export default "__VITE_ASSET__MKDqQU$P__"